import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import ChannelList from 'Components/Presentation/Channels/ChannelList';
import ChannelEditContainer from './Edit';

import AllChannelsQuery from 'GraphQueries/Channels/AllQuery';
import NewChannelMutation from 'GraphQueries/Channels/NewMutation';
import NewChannelSubscription from 'GraphQueries/Channels/NewSubscription';
import DeleteChannelMutation from 'GraphQueries/Channels/DeleteMutation';
import DeleteChannelSubscription from 'GraphQueries/Channels/DeleteSubscription';

class ChannelIndexContainer extends React.Component {
    
    static defaultProps = {
        channels: [],
        loading: false
    }

    state = { 
        channel: null,
        saving: false
    }

    componentDidMount() {
        const { subscribeToChanges } = this.props;
        subscribeToChanges();
    }

    navigateWithData = (uri, channel) => {
        const { history } = this.props;
        this.setState({ channel });
        history.push(uri);
    }

    saveChannel = async (channel) => {
        const { onAlert, onAdd } = this.props;
        this.setState({ saving: true });
        onAdd(channel).then(x => {
            this.setState({ saving: false });
            this.navigateWithData(`/data-classifications/channels/${channel.id}/manage/settings`, channel);
            onAlert('success', `Successfully added channel: ${channel.id}`);
        }).catch(error => {
            if(error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to add channels, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    deleteChannel = async (channel) => {
        const { onAlert, onDelete } = this.props;
        this.setState({ saving: true });
        onDelete(channel.id).then(x => {
            this.setState({ saving: false });
            onAlert('success', `Successfully deleted channel: ${channel.id}`);
        }).catch(error => {
            if(error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to delete channels, please see a System Admin');
                    }
                    else { onAlert('error', message); }
                });
            }
            this.setState({ saving: false });
        })
    }

    render() {
        const { channels, loading } = this.props;
        const { channel, saving } = this.state;
        return (
            <React.Fragment>
                <Route path="/data-classifications/channels" exact render={props => {
                    return (
                        <ChannelList {...props} loading={loading || saving} onEdit={this.navigateWithData} channels={channels}
                            onChannelAdded={this.saveChannel} onChannelRemoved={this.deleteChannel} />
                    )}
                } />
                <Route path="/data-classifications/channels/list" render={props => {
                    return (
                        <ChannelList {...props} loading={loading || saving} onEdit={this.navigateWithData} channels={channels}
                            onChannelAdded={this.saveChannel} onChannelRemoved={this.deleteChannel} />
                    )}
                } />
                <Route path="/data-classifications/channels/:id/manage" render={routeProps => {
                    return (
                        <ChannelEditContainer {...this.props} {...routeProps} channel={channel} />
                    )}
                } />
            </React.Fragment>
        );
    }
}

export default compose(
    graphql(AllChannelsQuery(), {
        props: ({ data: { listChannels, loading, subscribeToMore } }) => ({ 
            channels: listChannels && listChannels.items, 
            loading,
            subscribeToChanges: params => {
                subscribeToMore({
                    document: NewChannelSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onCreateChannel } } }) => ({
                        ...prev,
                        listChannels: { items: [onCreateChannel, ...prev.listChannels.items.filter(item => item.id !== onCreateChannel.id)], __typename: 'Channel' }
                    })
                });
                subscribeToMore({
                    document: DeleteChannelSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onDeleteChannel } } }) => ({
                        ...prev,
                        listChannels: { items: [...prev.listChannels.items.filter(item => item.id !== onDeleteChannel.id)], __typename: 'Channel' }
                    })
                });
            }
        })
    }),
    graphql(NewChannelMutation(), { props: ({ mutate }) => ({ onAdd: input => mutate({ variables: { input } }) }) }),
    graphql(DeleteChannelMutation(), { props: ({ mutate }) => ({ onDelete: id => mutate({ variables: { id } }) }) })
)(ChannelIndexContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Channels/Index.js